export default "https://assets-v2.scaler.com/packs/files/grouprewards.7e9953.webp";